'use client'

import {XEmbed} from 'react-social-media-embed'
import {cn} from '~/design-system/utils'

export type HgXEmbedProps = {
  url: string
  className?: string
}

export const HgXEmbed = ({url, className}: HgXEmbedProps) => (
  <div className={cn('flex justify-center', className)}>
    <XEmbed
      data-chromatic="ignore"
      className="min-w-[260px] max-w-[550px]"
      url={url}
      width="100%"
      height="100%"
    />
  </div>
)
